import axios from 'axios';
import { COOKIE_NAMES, USER_API_ENDPOINT } from '../constants';
import Cookies from 'js-cookie';
import { AxiosUtil } from '../utils/axios';

// @ts-ignore
const http = axios.create({
  baseURL: USER_API_ENDPOINT,
});
const accessToken = Cookies.get(COOKIE_NAMES.COOKIE_ACCESS_TOKEN);
if (!http.defaults.headers['Authorization'] && accessToken) {
  http.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
}
AxiosUtil.handleAutoRefreshToken(http);
http.interceptors.response.use((response) => response.data);
export default http;
